import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vdd-enum-readonly-no-interval',
  templateUrl: './vdd-enum-readonly-no-interval.component.html',
  styleUrls: ['./vdd-enum-readonly-no-interval.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddEnumReadonlyNoIntervalComponent {
  @Input() value: string;
  @Input() label: string;
  constructor() {}
}
